// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1605": "d388c75f","2530": "e96a97f9","2895": "fa85db70","5257": "88225f65","5395": "7bf34428",}[chunkId] + ".css"
}